<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
              <div class="col-12">
                <div v-if="isBigManager" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-1" value="1">
                    <label for="search-type-1">小額調撥({{NAPData.count_a}})</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-2" value="2">
                    <label for="search-type-2">失聯件排除({{NAPData.count_b}})</label>
                </div>
                <div v-if="isBigManager_unit" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-3" value="3">
                    <label for="search-type-3">實質接觸排除</label>
                </div>
                <div v-if="isBigManager_unit" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-4" value="4">
                    <label for="search-type-4">未訪/自招未訪件排除</label>
                </div>
                <div v-if="isBigManager_unit" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-8" value="8">
                    <label for="search-type-8">準未訪/自招未訪件排除</label>
                </div>
                <div v-if="isBigManager" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-0" value="0">
                    <label for="search-type-0">當日已覆核  (</label>
                </div>
                <div v-if="isBigManager" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-5" value="5" :disabled="type0status">
                    <label for="search-type-5">服務件調撥</label>
                </div>
                <div v-if="isBigManager" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-6" value="6" :disabled="type0status">
                    <label for="search-type-6">小額調撥/失聯件排除  )</label>
                </div>
                <div v-if="isBigManager" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-7" value="7">
                    <label for="search-type-7">前主管服務件自留</label>
                </div>
                <div v-if="isBigManager" class="radio radio-inline">
                    <input type="radio" v-model="searchType" id="search-type-10" value="10">
                    <label for="search-type-10">解鎖自招件可撥給非增員者</label>
                </div>
                <div class="text-red">NAP主管待辦【服務件業務覆核】顯示的累計件數=各申請單位小額調撥件數+各拜訪月份失聯件排除件數</div>
                <hr>
                
              </div>
             
            </div>
            <div class="row" v-show="searchType=='1'">
              <div class="col-12">
                <form action="" class="form">
                  <div class="form-group row" :class="{'section-loading': isDataLoading_type1}">
                    <label for="" class="col-2 text-center">申請單位</label>
                    <div class="col-5" v-if="type1_unitOpt.length > 0">
                      <select 
                        v-model="selectedUnitOptData" 
                        class="form-control" 
                        style="width:320px" 
                        @change="queryType1NrechargePl_List(selectedUnitOptData.ceclcar)">
                      <option
                        v-for="(unit, unitOptIndex) in type1_unitOpt"
                        :key="`service-unit-${unitOptIndex}`"
                        :value="unit">{{unit.cedvnm}}</option>
                      </select>
                    </div>
                    <label v-else>無任何待確認覆核之調撥件可選擇</label>
                    <!-- <div class="col-3">
                      <select v-model="form.area" class="form-control" :disabled="form.agency==''">
                        <option value="">請選擇區處</option>
                        <option value="2">A 區</option>
                        <option value="5">B 區</option>
                      </select>
                    </div> -->
                  </div>
                </form>
                <section class="insurance-table newTable">
                  <div :class="{'section-loading': isDataLoading_type1}">
                    <table class="table datatable table-striped table-bordered">
                      <thead>
                        <tr>
                          <th width="60">
                            <div class="checkbox checkbox-inline mr-0">
                              <input
                              @click="checkAll = checkAll == 'type1-all'?`type1-all-again`: 'type1-all'"
                              type="checkbox"
                              :name="`check-type1-all`" 
                              :id="`check-type1-all`"
                              v-model="checkAllClickType1">
                              <label :for="`check-type1-all`"></label>
                            </div>
                          </th>
                          <th>要保人</th>
                          <th>保單號碼</th>
                          <th>原服務人員</th>
                          <th>新服務人員</th>
                          <th>申請主管</th>
                          <th>申請日期</th>
                        </tr>
                      </thead>
                      <tbody v-if="type1Data.length">
                        <tr v-for="(item, index) in type1Data" :key="`type1-${index}`">
                          <td>
                            <div class="mr-0 checkbox checkbox-inline">
                              <input
                              @click="checkAll = checkAll == `type1-td-${index}`? `type1-td-${index}-again`: `type1-td-${index}`"
                              type="checkbox"
                              :name="`check-type1-td-item`"
                              :id="`check-type1-${index}`"
                              v-model="type1Selection"
                              :value="item">
                              <label :for="`check-type1-${index}`"></label>
                            </div>
                          </td>
                          <td>{{ item.ceapcnm }}</td>
                          <td>
                            {{ item.ceplcno }}
                            <br />
                            <span class="text-red">{{ item.change }}</span>
                          </td>
                          <td>{{ item.ceclcnm }}<br>{{ item.ceclcno }}</td>
                          <td>{{ item.ceclcnm_new }}<br>{{ item.ceclcno_new }}</td>
                          <td>{{ item.e5nm }}</td>
                          <td>{{ item.e5 | dateFormat }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td :colspan="7" class="empty-block bg-white">
                            <h3 class="bg-white">查無資料</h3>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
              <div class="col-12 text-right">
                <a class="btn btn-default" @click="delType1NreCharge()">退回</a>
                <a class="btn btn-primary" @click="confirmCheck()" :disabled="!type1Selection.length">確認覆核</a>
              </div>
            </div>
            
            <div class="row" v-show="searchType=='2'" :class="{'section-loading': isDataLoading_type2}">
              <div class="col-12">
                <form action="" class="form">
                  <div class="form-group">
                    <label>拜訪月份</label>
                    <select class="form-control form-control-inline" v-model="type2form.startYear">
                      <option
                      v-for="(year, yearIndex) in yearOpt"
                      :key="`service-year-${yearIndex}`"
                      :value="year.value">{{year.text}}</option>
                    </select>
                    <span class="text">/</span>
                    <select class="form-control form-control-inline" v-model="type2form.startMonth">
                      <option
                      v-for="(month, monthIndex) in monthOpt"
                      :key="`service-month-${monthIndex}`"
                      :value="month.value">{{month.text}}</option>
                    </select>
                    <span class="text">～</span>
                    <select class="form-control form-control-inline" v-model="type2form.endYear">
                      <option
                      v-for="(year, yearIndex) in yearOpt"
                      :key="`service-year-${yearIndex}`"
                      :value="year.value">{{year.text}}</option>
                    </select>
                    <span class="text">/</span>
                    <select class="form-control form-control-inline" v-model="type2form.endMonth">
                      <option
                      v-for="(month, monthIndex) in monthOpt"
                      :key="`service-month-${monthIndex}`"
                      :value="month.value">{{month.text}}</option>
                    </select>
                    <a class="btn btn-primary mt-0" @click="search()">查詢</a>
                    <span class="float-right mt-3">資料更新日期：108/2/27</span>
                  </div>
                </form>
                <section class="insurance-table newTable">
                  <div>
                    <table class="table datatable table-striped table-bordered">
                      <thead>
                        <tr>
                          <th width="60">
                            <div class="checkbox checkbox-inline mr-0">
                              <input
                              @click="checkAll = checkAll == 'type2-all'?`type2-all-again`: 'type2-all'"
                              type="checkbox"
                              :name="`check-type2-all`" 
                              :id="`check-type2-all`"
                              v-model="checkAllClickType2">
                              <label :for="`check-type2-all`"></label>
                            </div>
                          </th>
                          <th>要保人</th>
                          <th>保單號碼</th>
                          <th>服務人員</th>
                          <th>下次<br/>應繳日</th>
                          <th>契約<br/>效力</th>
                          <th>整合地址</th>
                          <th>拜訪狀況<br/>問題回報</th>
                        </tr>
                      </thead>
                      <tbody v-if="type2Data.length">
                        <tr v-for="(item, index) in type2Data" :key="`type2-${index}`">
                          <td>
                            <div class="mr-0 checkbox checkbox-inline">
                              <input
                              @click="checkAll = checkAll == `type2-td-${index}`? `type2-td-${index}-again`: `type2-td-${index}`"
                              type="checkbox"
                              :name="`check-type2-td-item`"
                              :id="`check-type2-${index}`"
                              v-model="type2Selection"
                              :value="item">
                              <label :for="`check-type2-${index}`"></label>
                            </div>
                          </td>
                          <td>{{ item.ceapcnm }}</td>
                          <td>{{ item.ceplcno }}</td>
                          <td>{{ item.clcid_nm }}<br>{{ item.clcno }}</td>
                          <td>{{ item.cenxpdt }}</td>
                          <td>{{ item.celpscs_nm }}</td>
                          <td><a class="link text-underline" @click="searchConnectInfoDetail(item.ceapcno, item.ceapcnm)">查詢</a></td>
                          <td>
                            <span v-if="item.contact == 5">遷址不明</span>
                            <span v-else-if="item.contact == 6">查無此址</span>
                            <span v-else-if="item.contact == 10">電話不正確</span>
                            <span v-else></span>
                          </td>
                          <div style="display:none">{{ item.clcid }}</div>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td :colspan="8" class="empty-block bg-white">
                            <h3 class="bg-white">{{table2msg}}</h3>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
              <div class="col-12">
                <span v-if="type2Data.length && type2Selection.length" class="float-right">
                  <a class="btn btn-primary" @click="type2Btn=false;confirmCheck()">取消覆核</a>
                  <a class="btn btn-primary" @click="type2Btn=true;confirmCheck()">覆核</a>
                </span>
                <!-- <ol>
                  <li>已完成親訪、電訪者無需主管覆核，只有失聯件需要覆核。</li>
                  <li>如有疑問請洽 總公司業務部業務企劃科，(02)27551399#2177、2056、2032</li>
                </ol> -->
                <p>如有疑問請洽 總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}</p>
              </div>
            </div>

            <div class="row" v-show="searchType=='3'">
              <div class="col-12">
                <form action="" class="form">
                  <div class="form-group row">
                    <label class="col-1">拜訪月份</label>
                    <div class="col-11">
                      <select v-model="type3exclusionForm.startYear" class="form-control form-control-inline ml-0">
                      <option
                      v-for="(year, yearIndex) in yearOpt"
                      :key="`service-year-${yearIndex}`"
                      :value="year.value">{{year.text}}</option>
                      </select>
                      <span class="text">/</span>
                      <select v-model="type3exclusionForm.startMonth" class="form-control form-control-inline">
                        <option
                        v-for="(month, monthIndex) in monthOpt"
                        :key="`service-month-${monthIndex}`"
                        :value="month.value">{{month.text}}</option>
                      </select>
                      <span class="text">～</span>
                      <select v-model="type3exclusionForm.endYear" class="form-control form-control-inline">
                      <option
                      v-for="(year, yearIndex) in yearOpt"
                      :key="`service-year-${yearIndex}`"
                      :value="year.value">{{year.text}}</option>
                      </select>
                      <span class="text">/</span>
                      <select v-model="type3exclusionForm.endMonth" class="form-control form-control-inline">
                        <option
                        v-for="(month, monthIndex) in monthOpt"
                        :key="`service-month-${monthIndex}`"
                        :value="month.value">{{month.text}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-1">收費代號</label>
                    <div class="col-3">
                      <input type="text"  value="clcno" v-model="type3form"  class="form-control forn-control-inline">
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-11 offset-1">
                      <a class="btn btn-primary mt-0 ml-0" @click="type3doSearch()">查詢</a>
                      <span class="float-right mt-3">資料更新日期：108/2/27</span>
                    </div>
                  </div>
                </form>
                <section class="insurance-table newTable">
                  <div :class="{'section-loading': isDataLoading_type3}">
                    <table class="table datatable table-striped table-bordered">
                      <thead>
                        <tr>
                          <th width="60">
                            <div class="checkbox checkbox-inline mr-0">
                              <input
                              @click="checkAllClick = true"
                              type="checkbox"
                              :name="`check-type3-all-again`" 
                              :id="`check-type3-all-again`"
                              v-model="type3CheckAll">
                              <label :for="`check-type3-all-again`"></label>
                            </div>
                          </th>
                          <th>列印<br/>日期</th>
                          <th>要保人</th>
                          <th>保單號碼</th>
                          <th>服務人員</th>
                          <th>下次<br/>應繳日</th>
                          <th>契約<br/>效力</th>
                          <th>整合地址</th>
                          <th>實質接<br/>觸期限</th>
                        </tr>
                      </thead>
                      <tbody v-if="type3Data.length">
                      <!-- <tbody> -->
                        <tr v-for="(item, index) in type3Data" :key="`type3-${index}`">
                          <td>
                            <div class="mr-0 checkbox checkbox-inline">
                              <input
                              @click="checkAllClick = false"
                              type="checkbox"
                              :name="`check-type3-td-item`"
                              :id="`check-type3-${index}`"
                              v-model="type3Selection"
                              :value="item">
                              <label :for="`check-type3-${index}`"></label>
                            </div>
                          </td>
                          <td>{{ item.print_day }}</td>
                          <td>{{ item.ceapcnm }}</td>
                          <td>{{ item.ceplcno }}</td>
                          <td>{{ item.clcid_nm }}<br>{{ item.clcno }}</td>
                          <td>{{ item.cenxpdt}}</td>
                          <td>{{ item.celpscs_nm }}</td>
                          <!-- <td><span>終身險<br/>滿期</span></td> -->
                          <td><a  class="link text-underline" @click="searchConnectInfoDetail(item.ceapcno, item.ceapcnm)">查詢</a></td>
                          <td>{{ item.last_visitday }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td :colspan="9" class="empty-block bg-white">
                            <h3 class="bg-white">{{table3msg}}</h3>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
              <div class="col-12">
                <a class="btn btn-primary float-right" disabled v-if="type3Selection.length == 0">覆核</a>
                <a class="btn btn-primary float-right" @click="confirmCheck()" v-else>覆核</a>
                <p>如有疑問請洽 總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}</p>
              </div>
            </div>

            <div class="row" v-show="searchType=='4'">
              <div class="col-12">
                <form action="" class="form">
                  <div class="form-group">
				            <label>收費代號</label>
                    <input type="text"  class="form-control form-control-inline form-wide ml-2" v-model="type4_selectedAg">
                    <a class="btn btn-primary mt-0 ml-0" @click="search()">查詢</a>
                  </div>
                </form>
                <section class="insurance-table newTable">
                  <div :class="{'section-loading': isDataLoading_type4}">
                    <table class="table datatable table-striped table-bordered">
                      <thead>
                        <tr>
                          <th width="60">
                            <div class="checkbox checkbox-inline mr-0">
                              <input
                              @click="checkAll = checkAll == 'type4-all'?`type4-all-again`: 'type4-all'"
                              type="checkbox"
                              :name="`check-type4-all`" 
                              :id="`check-type4-all`"
                              v-model="checkAllClickType4">
                              <label :for="`check-type4-all`"></label>
                            </div>
                          </th>
                          <th>要保人</th>
                          <th class="text-right">保單數</th>
                          <th>最近投保日期</th>
                          <!-- <th class="text-right">服務時間</th>
                          <th>開發價值</th> -->
                          <th width="250">備註</th>
                        </tr>
                      </thead>
                      <tbody v-if="type4Data.length">
                        <tr v-for="(item, index) in type4Data" :key="`type4-${index}`">
                          <td>
                            <div class="mr-0 checkbox checkbox-inline">
                              <input
                              @click="checkAll = checkAll == `type4-td-${index}`? `type4-td-${index}-again`: `type4-td-${index}`"
                              type="checkbox"
                              :name="`check-type4-td-item`"
                              :id="`check-type4-${index}`"
                              v-model="type4Selection"
                              :value="item">
                              <label :for="`check-type4-${index}`"></label>
                            </div>
                          </td>
                          <td>{{ item.ceapcnm }}</td>
                          <td class="text-right">{{ item.sum_ceplcno }}</td>
                          <td>{{ item.ceplcdt | dateFormat}}</td>
                          <!-- <td class="text-right">{{ item.service_time }}</td>
                          <td>{{ item.l_relation }}</td> -->
                          <td v-if='type4Selection.map(item => {return item.index}).includes(index)'><input maxlength="30" v-model="item.note"></td>
                          <td v-else>{{ item.note }}</td>
                          
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td :colspan="7" class="empty-block bg-white">
                            <h3 class="bg-white">點擊查詢顯示資料</h3>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
              <div class="col-12">
                <a class="btn btn-primary float-right" @click="confirmCheck()" :disabled="!type4Selection.length">覆核</a>
              </div>
            </div>

            <div class="row" v-show="searchType=='5'">
                <div class="col-12">
                    <div :class="{'section-loading': isDataLoading_type5}">
                      <table class="table datatable insurance-green">
                        <thead>
                          <tr>
                            <th width="60">
                              <div class="checkbox checkbox-inline mr-0">
                                <input
                                @click="checkAll = checkAll == 'type5-all'?`type5-all-again`: 'type5-all'"
                                type="checkbox"
                                :name="`check-type5-all`" 
                                :id="`check-type5-all`"
                                v-model="checkAllClickType5">
                                <label :for="`check-type5-all`"></label>
                              </div>
                            </th>
                            <th>要保人</th>
                            <th>保單號碼</th>
                            <th>原服務人員</th>
                            <th>新服務人員</th>
                            <th>申請主管</th>
                            <th>申請類別</th>
                            <th>申請日期</th>
                          </tr>
                        </thead>
                        <tbody v-if="type5Data.length">
                          <tr v-for="(item, index) in type5Data" :key="`type5-${index}`">
                            <td>
                              <div class="mr-0 checkbox checkbox-inline">
                                <input
                                @click="checkAll = checkAll == `type5-td-${index}`? `type5-td-${index}-again`: `type5-td-${index}`"
                                type="checkbox"
                                :name="`check-type5-td-item`"
                                :id="`check-type5-${index}`"
                                v-model="type5Selection"
                                :value="item">
                                <label :for="`check-type5-${index}`"></label>
                              </div>
                            </td>
                            <td>{{ item.ceapcnm }}</td>
                            <td>{{ item.ceplcno }}</td>
                            <td>{{ item.agname_old }}</td>
                            <td>{{ item.agname_new }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.code_nm }}</td>
                            <td>{{ item.date }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                        <tr>
                          <td :colspan="8" class="empty-block bg-white">
                            <h3 class="bg-white">查無資料</h3>
                          </td>
                        </tr>
                      </tbody>
                      </table>
                    </div>
                </div>
                <div class="col-12">
                  <a class="btn btn-primary float-right" @click="confirmCheck()" :disabled="!type5Selection.length">取消覆核</a>
                </div>
            </div>

            <div class="row" v-show="searchType=='6'">
                <div class="col-12">
                    <div :class="{'section-loading': isDataLoading_type6}">
                      <table class="table datatable insurance-green">
                        <thead>
                          <tr>
                            <th width="60">
                              <div class="checkbox checkbox-inline mr-0">
                                <input
                                @click="checkAll = checkAll == 'type6-all'?`type6-all-again`: 'type6-all'"
                                type="checkbox"
                                :name="`check-type6-all`" 
                                :id="`check-type6-all`"
                                v-model="checkAllClickType6">
                                <label :for="`check-type6-all`"></label>
                              </div>
                            </th>
                            <th>要保人</th>
                            <th>保單號碼</th>
                            <th>原服務人員</th>
                            <th>新服務人員</th>
                            <th>申請主管</th>
                            <th>申請類別</th>
                            <th>申請日期</th>
                          </tr>
                        </thead>
                        <tbody v-if="type6Data.length">
                          <tr v-for="(item, index) in type6Data" :key="`type6-${index}`">
                            <td>
                              <div class="mr-0 checkbox checkbox-inline">
                                <input
                                @click="checkAll = checkAll == `type6-td-${index}`? `type6-td-${index}-again`: `type6-td-${index}`"
                                type="checkbox"
                                :name="`check-type6-td-item`"
                                :id="`check-type6-${index}`"
                                v-model="type6Selection"
                                :value="item">
                                <label :for="`check-type6-${index}`"></label>
                              </div>
                            </td>
                            <td>{{ item.ceapcnm }}</td>
                            <td>{{ item.plcno }}</td>
                            <td>{{ item.ceclcnm_old }}<br>{{ item.ceclcno_old }}</td>
                            <td>{{ item.ceclcnm_new | emptyField }}<br>{{ item.ceclcno_new | emptyField }}</td>
                            <td>{{ item.e5nm }}</td>
                            <td>{{ item.type }}</td>
                            <td>{{ item.e5 }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td :colspan="8" class="empty-block bg-white">
                              <h3 class="bg-white">查無資料</h3>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                </div>
                <div class="col-12">
                  <a class="btn btn-primary float-right" @click="confirmCheck()" :disabled="!type6Selection.length">取消覆核</a>
                </div>
            </div>

            <div class="row" v-show="searchType=='7'">
                <div class="col-12">
                    <div :class="{'section-loading': isDataLoading_type7}">
                      <table class="table datatable insurance-green">
                        <thead>
                          <tr>
                            <th width="60">
                              <div class="checkbox checkbox-inline mr-0">
                                <input
                                @click="checkAll = checkAll == 'type7-all'?`type7-all-again`: 'type7-all'"
                                type="checkbox"
                                :name="`check-type7-all`" 
                                :id="`check-type7-all`"
                                v-model="checkAllClickType7">
                                <label :for="`check-type7-all`"></label>
                              </div>
                            </th>
                            <th>收費代號</th>
                            <th>職級</th>
                            <th>前任主管</th>
                            <th>現任主管</th>
                            <th>要保人數</th>
                            <th>保單件數</th>
                          </tr>
                        </thead>
                        <tbody v-if="type7Data.length">
                          <tr v-for="(item, index) in type7Data" :key="`type7-${index}`">
                            <td>
                              <div class="mr-0 checkbox checkbox-inline">
                                <input
                                @click="checkAll = checkAll == `type7-td-${index}`? `type7-td-${index}-again`: `type7-td-${index}`"
                                type="checkbox"
                                :name="`check-type7-td-item`"
                                :id="`check-type7-${index}`"
                                v-model="type7Selection"
                                :value="item">
                                <label :for="`check-type7-${index}`"></label>
                              </div>
                            </td>
                            <td>{{ item.clcno }}</td>
                            <td>{{ item.cepsnnm }}</td>
                            <td>{{ item.o_ceempnm }}</td>
                            <td>{{ item.ceempnm }}</td>
                            <td>{{ item.tmp7 }}</td>
                            <td>{{ item.tmp0 }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td :colspan="7" class="empty-block bg-white">
                              <h3 class="bg-white">查無資料</h3>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                </div>
                <div class="col-12">
                  <a class="btn btn-primary float-right" @click="confirmCheck()" :disabled="!type7Selection.length">覆核</a>
                  <p>備註:前主管服務件自留後，次一工作日會產生異動後實質接觸明細，次二工作日會列入強制調撥已完成。</p>
                </div>
            </div>

            <!-- 準未訪/自招未訪件排除-->
          <div class="row" v-show="searchType=='8'">
            <div class="col-12">
              <form action class="form">
                <div class="form-group">
                  <label>收費代號</label>
                  <input
                    type="text"
                    class="form-control form-control-inline form-wide ml-2"
                    v-model="input_ceclcno"
                  />
                  <a class="btn btn-primary mt-0 ml-0" @click="queryType8List()">查詢</a>
                </div>
              </form>
              <section class="insurance-table newTable">
                <div :class="{'section-loading': isDataLoading_type8}">
                  <table class="table datatable table-striped table-bordered">
                    <thead>
                      <tr>
                        <th width="60">
                          <div class="checkbox checkbox-inline mr-0">
                            <input
                              @click="checkAll = checkAll == 'type8-all'?`type8-all-again`: 'type8-all'"
                              type="checkbox"
                              :name="`check-type8-all`"
                              :id="`check-type8-all`"
                              v-model="checkAllClickType8"
                            />
                            <label :for="`check-type8-all`"></label>
                          </div>
                        </th>
                        <th
                          id="th_ceapcnm"
                          :class="'sorting ' + (order_col.fieldName == 'ceapcnm' ? (order_col.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                          @click="columnSorting('ceapcnm')"
                        >要保人</th>
                        <th class="text-right">保單數</th>
                        <th>最近投保日期</th>
                        <th width="250">備註</th>
                      </tr>
                    </thead>
                    <tbody v-if="type8Data.length">
                      <tr v-for="(item, index) in type8Data" :key="`type8-${index}-${item.ceclcid}`">
                        <td>
                          <div class="mr-0 checkbox checkbox-inline">
                            <input
                              @click="checkAll = checkAll == `type8-td-${index}`? `type8-td-${index}-again`: `type8-td-${index}`"
                              type="checkbox"
                              :name="`check-type8-td-item`"
                              :id="`check-type8-${index}`"
                              v-model="type8Selection"
                              :value="item"
                            />
                            <label :for="`check-type8-${index}`"></label>
                          </div>
                        </td>
                        <td>{{ item.ceapcnm }}</td>
                        <td class="text-right">{{ item.sum_ceplcno }}</td>
                        <td>{{ item.ceplcdt | dateFormat}}</td>
                        <td v-if="type8Selection.map(item => {return item.index}).includes(index)">
                          <input maxlength="30" v-model="item.note" />
                        </td>
                        <td v-else>{{ item.note }}</td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td :colspan="7" class="empty-block bg-white">
                          <h3 class="bg-white">點擊查詢顯示資料</h3>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            </div>
            <div class="col-12">
              <a
                class="btn btn-primary float-right"
                @click="confirmCheck()"
                :disabled="!type8Selection.length"
              >覆核</a>
            </div>
          </div>

          <div class="row" v-show="searchType=='10'" :class="{'section-loading': isDataLoading_type10}">
            <div class="col-12">
              <section class="insurance-table newTable">
                  <div>
                    <table class="table datatable table-striped table-bordered">
                      <thead>
                        <tr>
                          <th width="60"></th>
                          <th width="120">輸入日期</th>
                          <th width="120">收費代號</th>
                          <th width="120">姓名</th>
                          <th width="120">增員者</th>
                          <th width="130">申請人員姓名</th>
                          <th>輸入原因</th>
                        </tr>
                      </thead>
                      <tbody v-if="type10Data.length">
                        <tr v-for="(item, index) in type10Data" :key="`type10-${index}`">
                          <td>
                            <div class="mr-0 radio radio-inline">
                              <input
                                type="radio"
                                :name="`check-type10-td-item`"
                                :id="`check-type10-${index}`"
                                v-model="type10Selection"
                                :value="item"
                              />
                              <label :for="`check-type10-${index}`"></label>
                            </div>
                          </td>
                          <td>{{ item.c_upd_time.substring(0, item.c_upd_time.indexOf(" ")) }}</td>
                          <td>{{ item.resign_ceclcno }}</td>
                          <td>{{ item.resign_name }}</td>
                          <td>{{ item.intr_name }}</td>
                          <td>{{ item.c_id }}</td>
                          <td>{{ item.memo }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td :colspan="7" class="empty-block bg-white">
                            <h3 class="bg-white">查無資料</h3>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </section>
            </div>
            <div class="col-12 text-right">
                <a class="btn btn-primary" @click="doCheckUnlock" :disabled="!type10Selection.c_id">確認覆核</a>
              </div>
          </div>

        </div>
      </div>
    </div>
    <connect-data-modal
    :open="connectModalOpen"
    :loading="isConnectInfoLoading"
    :detailData="detailData"
    @close="panelClose('connectModalOpen')"/>
    
        
    <warning-modal
    :open="cancelCheckOpen"
    :cancelText="cancelCheckText"
    :message="cancelCheckMessage"
    @submit="cancelCheckSubmit"
    @close="panelClose('cancelCheckOpen')"
    />
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import WarningModal from '@/desktop/components/WarningModal'
import { debuglog, log } from 'util';
import ConnectDataModal from '@/desktop/components/manager/ConnectData'
import { queryNreChargeList, confirmNreCharge, delNreCharge } from '../../../service'  //type1function
import { queryChangeNcontact, updateChangeNcontact, cancelMissingLost} from '../../../service'  //type2function
import { queryChangeNEag ,queryChangeNIsexc ,queryBelowEstrangePolicyContactInfo,updateChangeNIsexc } from '../../../service'  ////type3function
import { queryEstrangeAgList, queryEstrangePlList, modifyEstrangePl } from '../../../service'  //type4function
import { getServiceTransferList, reviewServiceTransferList} from '../../../service'  //type5function
import { getSPlList, cancelSPl } from '../../../service'  //type6function
import { getFormerSupervisorServiceList, reviewFormerSupervisorServiceList} from '../../../service'  //type7function
import { queryUnvisitedList, approveUnvisitedList } from "@/service"; //type8function
import { queryForNAPServiceData } from "../../../service"; //NAP
import { getContactInfoBySerNo, doQueryResignList, doResignUnlock } from "@/service";

export default {
  name: 'TransferTab2',
  mixins: [commonMixin],
  components: {
    TabHeader, WarningModal,ConnectDataModal
  },
  computed: {
  },
  data () {
    return {
      searchType: '1',
      order: {
          currentTable: 1,
          index: 1,
          asc: true
      },
      detailData:{},
      isBigManager: true,  
      isBigManager_unit: true,  
      connectModalOpen:false,
      isConnectInfoLoading: false,
      type3CheckAll:false,
      checkAllClick:false,
      type3_Opt:[],
      type3exclusionForm:{
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: ''
      },
      type3form:'',
      cancelCheckText: '取消',
      cancelCheckMessage: '',
      cancelCheckOpen: false,
      checkAll: '',
      checkAllClickType1: false,
      checkAllClickType2: false,
      checkAllClickType3: false,
      checkAllClickType4: false,
      checkAllClickType5: false,
      checkAllClickType6: false,
      checkAllClickType7: false,
      checkAllClickType8: false, //準未訪/自招未訪件排除
      type1Data: [],
      isDataLoading_type1: false,
      type1_unitOpt: [],
      selectedUnitOptData: '',
      type2Data: [],
      isDataLoading_type2: false,
      type3Data: [],
      isDataLoading_type3: false,
      type4Data: [],
      isDataLoading_type4: false,
      type5Data: [],
      isDataLoading_type5: false,
      type6Data: [],
      isDataLoading_type6: false,
      type7Data: [],
      isDataLoading_type7: false,
      type8Data_init: [], //準未訪/自招未訪件排除
      type8Data: [], //準未訪/自招未訪件排除_呈現區塊
      isDataLoading_type8: false,
      type10Data: [],
      isDataLoading_type10: false,
      type4_AgOpt: [],
      type4_selectedAg: '',
      NAPData: {},
      table2msg: '點擊查詢顯示資料',
      table3msg: '點擊查詢顯示資料',
      type2form: {
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: '',
      },
      yearOpt: [],
      monthOpt: [],
      type1Selection: [],
      type2Selection: [],
      type3Selection: [],
      type4Selection: [],
      type5Selection: [],
      type6Selection: [],
      type7Selection: [],
      type8Selection: [], //準未訪/自招未訪件排除
      type10Selection: {},
      type0status: true, //當日已覆核選項，true為禁用服務件調撥&小額調撥/失聯件排除選項
      input_ceclcno: "", //收費代號
      order_col: {
        fieldName: "ceapcnm",
        asc: true
      },
      type2Btn:false, // 失聯件排除 取消覆核(false);覆核(true)
      contactInfo: []
    }
  },
  watch: {
    'searchType': 'changeType',
    checkAll: function(activeTarget){
      console.log(`頁籤 ${this.searchType} 的 table 點選欄位 ${activeTarget}`)
      switch(this.searchType) {
        case "1":
          this.type1checkBoxAction(activeTarget)
          break;
        case "2":
          this.type2checkBoxAction(activeTarget)
          break;
        case "4":
          this.type4checkBoxAction(activeTarget)
          break;
        case "5":
          this.type5checkBoxAction(activeTarget)
          break;
        case "6":
          this.type6checkBoxAction(activeTarget);
          break;
        case "7":
          this.type7checkBoxAction(activeTarget);
          break;
        case "8":
          this.type8checkBoxAction(activeTarget)
          break;
        default:
          console.log('頁籤 switch 為 default')
          break;
      }
    },
    'type2form.startYear': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'startYear')},
    'type2form.startMonth': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'startMonth')},
    'type2form.endYear': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'endYear')},
    'type2form.endMonth': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'endMonth')},
    'type3exclusionForm.startYear': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'startYear')},
    'type3exclusionForm.startMonth': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'startMonth')},
    'type3exclusionForm.endYear': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'endYear')},
    'type3exclusionForm.endMonth': function(newValue, oldValue) {this.checkDate(newValue, oldValue, 'endMonth')},
    type3CheckAll: function(val){
      if(val && this.checkAllClick) {
        this.type3Selection = []
        this.type3Data.forEach(data => {
          this.type3Selection.push(data)
        });
      } else if(this.checkAllClick){
        this.type3Selection = []
      }
    },
    type3Selection: function(){
      if(this.type3Data.length !== this.type3Selection.length && !this.checkAllClick){
        this.type3CheckAll = false
      }else if(!this.checkAllClick){
        this.type3CheckAll = true
      }
    },   
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    //==================== 頁籤切換&data轉換功能 ====================
    changeType (val) {
      this.order.currentTable = Number(val)
      this.input_ceclcno = "";
      switch(val) {
        case '1':
          this.type0status = true;
          this.initType1NreChargeList()
          break;
        case '2':
          this.type0status = true;
          break;
        case '3':
          this.type0status = true;
          //this.initType3Data() //2023.09.08確認沒有用到
          this.type3Data = []
          this.type3form = ''
          break;
        case '4':
          this.type0status = true;
          this.initType4Data()
          this.type4Data = []
          this.type4_selectedAg = ''
          break;
        case '5':
          this.initType5Data();
          break;
        case '6':
          this.initType6Data();
          break;
        case '7':
          this.type0status = true;
          this.initType7Data();
          break;
        case '0':
          this.type0status = false;
          break;
        case '8':
          this.type0status = true;
          this.type8Data = [];
          this.type4_selectedAg = '';
          break;
        case '10':
          this.initType10Data();
          break;
        default:
          break;
      }
      this.registerHanlink()  // 難字 update
    },
    search() {
      switch(Number(this.searchType)) {
        case 2:
          this.type2getContactList()
          break;
        case 3:
          break;
        case 4:
          this.type4searchPlList()
          break;
      }
    },
    updateHanlinkType3 () { // for 難字更新 實質接觸排除 服務人員
      this.registerHanlink()
    },
    confirmCheck () {
      switch(Number(this.searchType)) {
        case 2:
          if (this.type2Btn) {
            this.cancelCheckText = '取消';
            this.cancelCheckMessage = '您確定要覆核嗎？';
          } else {
            this.cancelCheckText = '先不要';
            this.cancelCheckMessage = '您確定要取消覆核嗎？';
          }
          this.panelOpen('cancelCheckOpen');
          break;
        case 1:
        case 3:
        case 4:
        case 7: 
        case 8:
          this.cancelCheckText = '取消';
          this.cancelCheckMessage = '您確定要覆核嗎？';
          this.panelOpen('cancelCheckOpen');
          break;
        case 5:
        case 6: 
          this.cancelCheckText = '先不要';
          this.cancelCheckMessage = '您確定要取消覆核嗎？';
          this.panelOpen('cancelCheckOpen');
          break;               
        default:
          break;
      }
    },
    cancelCheckSubmit () {
      switch(Number(this.searchType)) {
        case 1:
          this.type1cancelCheckSubmit();
          break;
        case 2:
          this.type2cancelCheckSubmit();
          break;
        case 3:
          this.type3cancelCheckSubmit();
          break;
        case 4:
          this.type4cancelCheckSubmit();
          break;
        case 5:
          this.type5cancelCheckSubmit();
          break;
        case 6:
          this.type6cancelCheckSubmit();
          break;
        case 7:
          this.type7cancelCheckSubmit();
          break;
        case 8:
          this.type8cancelCheckSubmit();
          break;
        default:
          break;
      }
    },
    type1checkBoxAction (activeTarget) {
      if(activeTarget == 'type1-all' || activeTarget == 'type1-all-again') {  //點了全選checkbox
        if(this.checkAllClickType1) {  //點了全選
          this.type1Selection = []
          this.type1Data.forEach(data => {
            this.type1Selection.push(data)
          });
        } else {  //取消全選
          this.type1Selection = []
        }
      } else {  //點了其他checkbox
        this.checkAllClickType1 = this.type1Data.length == this.type1Selection.length
      }
    }, 
    type2checkBoxAction (activeTarget) {
      if(activeTarget == 'type2-all' || activeTarget == 'type2-all-again') {  //點了全選checkbox
        if(this.checkAllClickType2) {  //點了全選
          this.type2Selection = []
          this.type2Data.forEach(data => {
            this.type2Selection.push(data)
          });
        } else {  //取消全選
          this.type2Selection = []
        }
      } else {  //點了其他checkbox       
        this.checkAllClickType2 = this.type2Data.length == this.type2Selection.length
      }
    }, 
    type4checkBoxAction (activeTarget) {
      if(activeTarget == 'type4-all' || activeTarget == 'type4-all-again') {  //點了全選checkbox
        if(this.checkAllClickType4) {  //點了全選
          this.type4Selection = []
          this.type4Data.forEach(data => {
            this.type4Selection.push(data)
          });
            
        }else {  //取消全選
          this.type4Selection = []
        }
      } else {  //點了其他checkbox
        
        this.checkAllClickType4 = this.type4Data.length == this.type4Selection.length
      }
    },
    type5checkBoxAction (activeTarget) {
      if(activeTarget == 'type5-all' || activeTarget == 'type5-all-again') {  //點了全選checkbox
        if(this.checkAllClickType5) {  //點了全選
          this.type5Selection = []
          this.type5Data.forEach(data => {
            this.type5Selection.push(data)
          });
        } else {  //取消全選
          this.type5Selection = []
        }
      } else {  //點了其他checkbox
        this.checkAllClickType5 = this.type5Data.length == this.type5Selection.length
      }
    },
    type6checkBoxAction (activeTarget) {
      if(activeTarget == 'type6-all' || activeTarget == 'type6-all-again') {  //點了全選checkbox
        if(this.checkAllClickType6) {  //點了全選
          this.type6Selection = [];
          this.type6Data.forEach(data => {
            this.type6Selection.push(data);
          });
        } else {  //取消全選
          this.type6Selection = [];
        }
      } else {  //點了其他checkbox
        this.checkAllClickType6 = this.type6Data.length == this.type6Selection.length;
      }
    },
    type7checkBoxAction (activeTarget) {
      if(activeTarget == 'type7-all' || activeTarget == 'type7-all-again') {  //點了全選checkbox
        if(this.checkAllClickType7) {  //點了全選
          this.type7Selection = [];
          this.type7Data.forEach(data => {
            this.type7Selection.push(data);
          });
        } else {  //取消全選
          this.type7Selection = [];
        }
      } else {  //點了其他checkbox
        this.checkAllClickType7 = this.type7Data.length == this.type7Selection.length;
      }
    },
    type8checkBoxAction(activeTarget) {
      if (activeTarget == "type8-all" || activeTarget == "type8-all-again") {
        //點了全選checkbox
        if (this.checkAllClickType8) {
          //點了全選
          this.type8Selection = [];
          this.type8Data.forEach(data => {
            this.type8Selection.push(data);
          });
        } else {
          //取消全選
          this.type8Selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAllClickType8 =
          this.type8Data.length == this.type8Selection.length;
      }
    },
    checkDate(newValue, oldValue, buttonTag) {
      if(oldValue != ''){
        let startDate;
        let endDate;
        switch(this.searchType) {
          case '2':
            startDate = Date.parse(`${this.type2form.startYear}/${this.type2form.startMonth}`)
            endDate = Date.parse(`${this.type2form.endYear}/${this.type2form.endMonth}`)
            if(startDate-endDate>0){
              this.type2form[buttonTag] = oldValue
              this.$toast.info({title: '起年月不可小於迄年月'});
            }
            break;
          case '3':
            startDate = Date.parse(`${this.type3exclusionForm.startYear}/${this.type3exclusionForm.startMonth}`)
            endDate = Date.parse(`${this.type3exclusionForm.endYear}/${this.type3exclusionForm.endMonth}`)
            if(startDate-endDate>0){
              this.type3exclusionForm[buttonTag] = oldValue
              this.$toast.info({title: '起年月不可小於迄年月'});
            }
            break;
          default:
            break;
        }
        
      }
    },
    //==================== 各頁籤功能 ====================
    queryType1NrechargePl_List(ceclcar) {
      this.isDataLoading_type1 = true
      this.type1Data = []
      queryNreChargeList(this.$store.state.userInfo.id, ceclcar, "selected").then( result => {
        if(result.header && "200" === result.header.status && result.body){
          if(result.body.query_nrechargepl){
            this.type1Data = result.body.query_nrechargepl
            this.isDataLoading_type1 = false
          } else {
            this.type1Data = []
            this.initType1NreChargeList()
          }
        } else {
          this.type1Data = []
          this.isDataLoading_type1 = false
        }
        this.registerHanlink()  // 難字 update
      })
    },
    delType1NreCharge(){
      let ceplcnoList = this.type1Selection.map(item => item.ceplcno);
      delNreCharge(this.$store.state.userInfo.id, ceplcnoList).then( result =>{
        if(result.header && "200" === result.header.status){
          this.$toast.info({title: result.header.message});
          this.type1Selection = []
          this.checkAllClickType1 = false
          this.queryType1NrechargePl_List(this.selectedUnitOptData.ceclcar)
        }
        else{
          this.$toast.info({title: result.header.message});
        }
      })
    },
    type2getContactList() {
      this.isDataLoading_type2 = true
      let lastDay = new Date(this.type2form.endYear, parseInt(this.type2form.endMonth), 0).getDate(); //取每月最後一天
      let startDate = `${this.type2form.startYear}-${this.type2form.startMonth}-01`
      let endDate = `${this.type2form.endYear}-${this.type2form.endMonth}-${lastDay}`
      let clcno_lv = this.type2generateClcnoLv()
      this.type2Data = []
      queryChangeNcontact(this.$store.state.userInfo.id, clcno_lv, startDate, endDate).then(result => {
        this.isDataLoading_type2 = false
        if(result.header && result.header.status === '200') {
          this.type2Data = result.body
        } else {
          this.type2Data = []
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '清單查詢失敗,請重新操作'})
          }
        }
        this.registerHanlink()
      })
    },
    type2generateClcnoLv() {
      let clcno = this.$store.state.userInfo.divNo
      if(this.$store.state.userInfo.divNo.substr(2, 1) == '4') {
        clcno = this.$store.state.userInfo.divNo.substr(0,2) + '5' + this.$store.state.userInfo.divNo.substr(3,5)
      }
      switch(this.$store.state.userInfo.roleId) {
        case 'SALES_MANAGER_02':
        case 'SALES_MANAGER_05':
        case 'SALES_MANAGER_06':
          return clcno.substr(0, 3)
          break;
        case 'SALES_MANAGER_03':
          return clcno.substr(0, 4)
          break;
        case 'SALES_MANAGER_04':
          return clcno.substr(0, 5)
          break;
      }
    },
    type3doSearch(){
      let ceclcno = this.type3form.trim();
      if (!ceclcno) {
        this.setToastMsg("收費代號不可為空");
        return;
      }
      this.isDataLoading_type3 = true
      let lastDay = new Date(this.type3exclusionForm.endYear, parseInt(this.type3exclusionForm.endMonth), 0).getDate(); //取每月最後一天
      let startDate = `${this.type3exclusionForm.startYear}-${this.type3exclusionForm.startMonth}-01`
      let endDate = `${this.type3exclusionForm.endYear}-${this.type3exclusionForm.endMonth}-${lastDay}`
      this.type3Data = []
      queryChangeNIsexc(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3), startDate, endDate, ceclcno).then(result=>{

        if(result.header && result.header.status === '200') {
          if(result.body.list){
            this.type3Data = result.body.list
          }else{
            this.$toast.info({title: result.header.message})
            this.type3Data = []
            
          }
        } else {
          this.type3Data = []
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '初始化失敗,請重新操作'})
          }
        }  
        this.isDataLoading_type3 = false
        this.registerHanlink()
      })
    },
    type4searchPlList () {
      let ceclcno = this.type4_selectedAg.trim();
      if (!ceclcno) {
        this.setToastMsg("收費代號不可為空");
        return;
      }
      this.isDataLoading_type4 = true
      this.type4Data = []
        queryEstrangePlList(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3), ceclcno).then(result => {
          if(result.header && result.header.status === '200') {
            this.type4Selection = []
            this.checkAllClickType4 = false
            this.type4Data = result.body.pl.map((item,index) => {
                return {
                  ceapcnm: item.ceapcnm,
                  ceapcno: item.ceapcno,
                  ceclcid: item.ceclcid,
                  ceclcno: item.ceclcno,
                  ceplcdt: item.ceplcdt,
                  note: item.note ? item.note :'',
                  sum_ceplcno: item.sum_ceplcno,
                  index: index,
                  ceclcar3: item.ceclcar3
               }            
            })
            this.$toast.info({title: result.header.message})
          } else {
            this.type4Data = []
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '清單查詢失敗,請重新操作'})
            }
          }
          this.isDataLoading_type4 = false
          this.registerHanlink()  // 難字 update
        }) 
    },
    searchConnectInfoDetail(ceapcno, ceapcnm){ //實質接觸排除整合地址查詢
      this.detailData = {}
      this.isConnectInfoLoading = true
      queryBelowEstrangePolicyContactInfo(this.$store.state.userInfo.id, ceapcno, ceapcnm).then(result=>{
        if(result.header && result.header.status === '200') {
            this.detailData = result.body.detail
        } else {
            this.detailData = {}
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '地址查詢失敗,請重新操作'})
          }
        }
        this.isConnectInfoLoading = false
        this.registerHanlink()
      })
      this.panelOpen('connectModalOpen') 
    },
    //查詢準未訪_自招未訪件
    queryType8List () {
      let ceclcno = this.input_ceclcno.trim();
      if (!ceclcno) {
        this.setToastMsg("收費代號不可為空");
        return;
      }
      this.isDataLoading_type8 = true;
      this.type8Data = [];
        queryUnvisitedList(this.$store.state.userInfo.id, ceclcno).then(result => {
          if(result.header && result.header.status === '200') {
            this.type8Selection = [];
            this.checkAllClickType8 = false;
            this.type8Data_init = result.body.result.map((item,index) => {
                return {
                  ceapcnm: item.ceapcnm,
                  ceapcno: item.ceapcno,
                  ceclcid: item.ceclcid,
                  ceclcno: item.ceclcno,
                  ceplcdt: item.ceplcdt,
                  note: item.note ? item.note : "",
                  sum_ceplcno: item.sum_ceplcno,
                  index: index,
                  ceclcar3: item.ceclcar3
               }
            })
            this.type8Data = [...this.type8Data_init];
          } else {
            this.type8Data = [];
            if(result.header.message) {
              this.$toast.info({title: result.header.message});
            } else {
              this.$toast.info({title: "準未訪/自招未訪件查詢失敗,請重新操作"});
            }
          }
          this.isDataLoading_type8 = false;
          this.registerHanlink();  // 難字 update
        }) 
    },
    type1cancelCheckSubmit () {
      let error_no = [];
      this.type1Selection.forEach(ele => {
        if (ele.change) {
          error_no.push(ele.ceplcno);
        }
      });

      if (error_no.length > 0) {
        this.$toast.info({
          title: "已異動保單無法覆核：" + error_no.join("，")
        });
        this.panelClose("cancelCheckOpen");
        return;
      }

      // 'A8100'
      confirmNreCharge(this.$store.state.userInfo.id, this.$store.state.userInfo.name, this.type1Selection, this.$store.state.userInfo.divNo).then(result => {
        if(result.header && result.header.status === '200') {
          this.type1Selection = []
          this.checkAllClickType1 = false
          this.$toast.info({title: result.header.message})
          //差 init
          this.queryType1NrechargePl_List(this.selectedUnitOptData.ceclcar)
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '執行失敗,請重新操作'})
          }
        }
      })
      this.panelClose('cancelCheckOpen')
    },
    type2cancelCheckSubmit() {
      if (this.type2Btn) {
        //覆核
        this.isDataLoading_type2 = true;
        updateChangeNcontact(this.$store.state.userInfo.id, this.type2Selection).then(result => {
          this.isDataLoading_type2 = false;
          if(result.header && result.header.status === '200') {
            this.type2Selection = []
            this.checkAllClickType2 = false
            this.$toast.info({title: result.header.message})
            this.type2getContactList()
          } else {
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '覆核失敗'})
            }
          }
          this.panelClose('cancelCheckOpen')
        })
      } else {
        //取消覆核
        this.cancelMissing();
      }
    },
    type3cancelCheckSubmit () {
      updateChangeNIsexc(this.$store.state.userInfo.id, this.type3Selection).then(result => {
        if(result.header && result.header.status === '200') {
          this.type3Data = []
          this.$toast.info({title: result.header.message})
          //this.initType3Data()  //2024.06.12確認覆核後不要再查詢拜訪件人員
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '覆核失敗'})
          }
        }
      })
      this.panelClose('cancelCheckOpen')
    },
    type4cancelCheckSubmit () {
      modifyEstrangePl(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3), this.type4Selection).then(result => {
        if(result.header && result.header.status === '200') {
          this.type4Selection = []
          this.checkAllClickType4 = false
          this.$toast.info({title: result.header.message})
          this.type4searchPlList()
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '覆核失敗'})
          }
        }
      })
      this.panelClose('cancelCheckOpen')
    },
    type5cancelCheckSubmit () {
      this.isDataLoading_type5 = true;
      reviewServiceTransferList(this.$store.state.userInfo.id, this.type5Selection).then(result => {
        if(result.header && result.header.status === '200') {
          this.type5Selection = [];
          this.checkAllClickType5 = false;
          this.$toast.info({title: result.header.message});
          this.initType5Data();
        } else {
          if (result.header.message) {
            this.$toast.info({title: result.header.message});
          } else {
            this.$toast.info({title: '取消覆核失敗'});
          }
        }
        this.isDataLoading_type5 = false;
      })
      this.panelClose('cancelCheckOpen');
    },
    type6cancelCheckSubmit () {
      cancelSPl(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3), this.type6Selection).then(result => {
        if(result.header && result.header.status === '200') {
          this.type6Selection = [];
          this.checkAllClickType6 = false;
          this.$toast.info({title: result.header.message})
          this.initType6Data();
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message});
          } else {
            this.$toast.info({title: '執行失敗,請重新操作'});
          }
        }
      })
      this.panelClose('cancelCheckOpen')
    },
    type7cancelCheckSubmit () {
      this.isDataLoading_type7 = true;
      reviewFormerSupervisorServiceList(this.$store.state.userInfo.id, this.type7Selection).then(result => {
        if(result.header && result.header.status === '200') {
          this.type7Selection = [];
          this.checkAllClickType7 = false;
          this.$toast.info({title: result.header.message});
          this.initType7Data();
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message});
          } else {
            this.$toast.info({title: '覆核失敗'});
          }
        }
        this.isDataLoading_type7 = false;
      })
      this.panelClose('cancelCheckOpen');
    },
    //準未訪/自招未訪件覆核
    type8cancelCheckSubmit() {
      this.isDataLoading_type8 = true;
      approveUnvisitedList(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.divNo.slice(0, 3),
        this.type8Selection
      ).then(result => {
        this.isDataLoading_type8 = false;
        if (result.header && result.header.status === "200") {
          this.type8Selection = [];
          this.checkAllClickType8 = false;
          this.$toast.info({ title: result.header.message });
          this.queryType8List(); //覆核後執行重新查詢
        } else {
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "覆核失敗" });
          }
        }
      });
      this.panelClose("cancelCheckOpen");
    },
    sortCompareFun(sortOrder, property, subProperty) {
      return function(a, b) {
        let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        if(result == 0) {
          result = (a[subProperty] < b[subProperty]) ? -1 : (a[subProperty] > b[subProperty]) ? 1 : 0;
        }
        return result * sortOrder;
      }
    },
    //==================== 初始化功能 ====================
    initType1NreChargeList(){
      //  'A8100'
      this.isDataLoading_type1 = true
      queryNreChargeList(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo, 'init').then( result => {
        if(result.header && "200" === result.header.status && result.body){
          if(result.body.query_nrechargeunit){
            this.type1_unitOpt = result.body.query_nrechargeunit
            this.selectedUnitOptData = result.body.query_nrechargeunit[0]
          } else {
            this.type1_unitOpt = []
            this.selectedUnitOptData = {}
          }
          if(result.body.query_nrechargepl){
            this.type1Data = result.body.query_nrechargepl
            this.type1Data.sort(this.sortCompareFun(1 , 'ceapcnm', 'ceplcno'))
          } else {
            this.type1Data = []
          }
        }
        this.isDataLoading_type1 = false
        this.registerHanlink()  // 難字 update
      })
    },
    initType3Data () {
      queryChangeNEag(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3)).then(result=>{
        if(result.header && result.header.status === '200') {
          this.type3_Opt = result.body.ag
        } else {
          this.type3_Opt = []
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '初始化失敗,請重新操作'})
          }
        } 
      })  
    },
    initType4Data () {
      queryEstrangeAgList(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3)).then(result => {
        if(result.header && result.header.status === '200') {
          this.type4_AgOpt = result.body.ag
        } else {
          this.type4_AgOpt = []
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '初始化失敗,請重新操作'})
          }
        }
        this.registerHanlink()  // 難字 update
      })
    },
    initType5Data () {
      this.isDataLoading_type5 = true;
      getServiceTransferList(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3)).then(result => {
        if(result.header && result.header.status === '200') {
          this.type5Data = result.body.result;
        } else {
          this.type5Data = [];
          if(result.header.message) {
            this.$toast.info({title: result.header.message});
          } else {
            this.$toast.info({title: '初始化失敗,請重新操作'});
          }
        }
        this.registerHanlink()  // 難字 update
        this.isDataLoading_type5 = false;
      })
    },
    initType6Data () {
      this.isDataLoading_type6 = true;
      this.type6Data = [];
      getSPlList(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3)).then(result => {
        if(result.header && result.header.status === '200') {
          this.type6Data = result.body.query_sp1_list.concat(result.body.query_sp2_list);
          this.type6Data.sort(this.sortCompareFun(1, "type", "plcno"));
        } else {
          this.type6Data = [];
          if(result.header.message) {
            this.$toast.info({title: result.header.message});
          } else {
            this.$toast.info({title: '初始化失敗,請重新操作'});
          }
        }
        this.registerHanlink();  // 難字 update
        this.isDataLoading_type6 = false;
      })
    },
    initType7Data () {
      this.isDataLoading_type7 = true;
      this.type7Data = [];
      getFormerSupervisorServiceList(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3)).then(result => {
        if(result.header && result.header.status === '200') {
          this.type7Data = result.body.result;
        } else {
          this.type7Data = [];
          if(result.header.message) {
            this.$toast.info({title: result.header.message});
          } else {
            this.$toast.info({title: '初始化失敗,請重新操作'});
          }
        }
        this.registerHanlink()  // 難字 update
        this.isDataLoading_type7 = false;
      })
    },
    /** 查詢離退人員主管未覆核資料清單 */
    initType10Data() {
      this.isDataLoading_type10 = true;
      const cedvno3 = this.$store.state.userInfo.divNo.substring(0, 3);
      doQueryResignList(this.$store.state.userInfo.id, cedvno3, "IS_CHECK", null).then(result => {
        this.isDataLoading_type10 = false;
        if (result && result.header.status == "200" && result.body) {
          this.type10Data = result.body.rtn_list || [];
        }
      });
    },
    getNAPData(){
      queryForNAPServiceData(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo).then(result =>{
        if(result.header && result.header.status === '200') {
          this.NAPData = result.body;
        } else {
          this.NAPData = {};
          if(result.header.message) {
            this.$toast.info({title: result.header.message});
          } else {
            this.$toast.info({title: '初始化失敗,請重新操作'});
          }
        }     
      })
    },
    initMonthOpt() {
      for(var i=1; i<13; i++) {
        let selectItem = {
          value: String(i).length == 1 ? '0' + String(i) : String(i),
          text: `${i}月`
        }
        this.monthOpt.push(selectItem)
      }
      let currentMonth = String(new Date().getMonth() +1)
      if(currentMonth.length == 1) {
        currentMonth = '0' + currentMonth
      }
      this.type2form.startMonth = currentMonth
      this.type2form.endMonth = currentMonth
      this.type3exclusionForm.startMonth = currentMonth
      this.type3exclusionForm.endMonth = currentMonth
    },
    initYearOpt() {
      let westYear = new Date().getFullYear()
      for(var i=westYear-5; i<=westYear; i++) {
        let selectItem = {
          value: String(i),
          text: `${i - 1911}年`
        }
        this.yearOpt.push(selectItem)
      }
      let currentWestYear = String(westYear)
      this.type2form.startYear = currentWestYear
      this.type2form.endYear = currentWestYear
      this.type3exclusionForm.startYear = currentWestYear
      this.type3exclusionForm.endYear = currentWestYear
    },
    initTransferTab2() {
      // 判別是否為經理版權限
      if(this.$store.state.userInfo.roleId == 'SALES_MANAGER_02' || (this.$store.state.userInfo.roleId == 'SALES_MANAGER_06' && this.$store.state.userInfo.functionId.includes('3'))) {
        this.isBigManager = true;
        this.isBigManager_unit = false;
        this.initType1NreChargeList();
        //this.initType3Data(); //2023.09.08確認沒有用到
        this.initType4Data();
        this.initType5Data();
        this.initType6Data();
        this.getNAPData();
      } else {
        if(this.$store.state.userInfo.divNo == '0500100' ) {
        this.isBigManager = false;
        this.isBigManager_unit = true;
        //this.initType3Data(); //2023.09.08確認沒有用到
        } else {
        this.isBigManager = false; 
        this.isBigManager_unit = false;
        this.getNAPData();
        this.searchType = '2';
        }
      }
      
      this.initMonthOpt()
      this.initYearOpt()
    },
    //處理排序
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order_col.fieldName == fieldName) {
        this.order_col.asc = !this.order_col.asc;
      } else {
        this.order_col.fieldName = fieldName;
        this.order_col.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order_col.asc) {
        sortOrder = 1;
      }

      this.type8Data = [];
      setTimeout(() => {
        this.type8Data = [...this.type8Data_init];
        this.type8Data.sort(this.sortCompareFun(sortOrder, fieldName));
        this.registerHanlink(); // for 難字更新
      }, 20);
    },
    //取消覆核(取消失聯)
    cancelMissing() {
      this.isDataLoading_type2 = true;
      let visitNoList = [];
      this.type2Selection.forEach(item => {
        visitNoList.push(item.visit_no);
      })
      cancelMissingLost(
        this.$store.state.userInfo.id,
        visitNoList
      ).then(result => {
        this.isDataLoading_type2 = false;
        if (result.header && result.header.status === '200') {
          this.type2Selection = [];
          this.checkAllClickType2 = false;
          this.setToastMsg(result.header.message);
          this.type2getContactList();
        } else {
            if (result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '取消覆核失敗'})
            }
        }
        this.panelClose('cancelCheckOpen');
      });
    },
    /** 覆核解鎖自招件可撥給非增員者 */
    doCheckUnlock() {
      const reqData = {
        resign_id: this.type10Selection.resign_id,
        intr_id: this.type10Selection.intr_id,
        page: "check",
        agidno: this.$store.state.userInfo.id
      };
      doResignUnlock(this.$store.state.userInfo.id, reqData).then(result => {
        if (result && result.header.status == "200" && result.body) {
          this.$toast.info({ title: "覆核成功" });
          this.type10Selection = {};
          this.type10Data = [];
          this.initType10Data();
        } else {
          this.$toast.info({ title: "覆核失敗" });
        }
      });
    }
  },
  beforeMount () {
    this.initTransferTab2()
  },
  mounted () {
    // 以流水編號查詢企劃單位連絡方式
    getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
      if(result && result.header.status == '200' && result.body){
          this.contactInfo  = result.body.lists[0];
      }
    })
  }
}
</script>